// Stripe Payment Link for Shoebox Plus at $60/year, with no trial
const CHECKOUT_URL = "https://buy.stripe.com/6oUfZg75F6Ob28j5eR1RC04";
// Stripe's customer portal, for updating a card or cancelling
const BILLING_PORTAL_URL = "https://billing.stripe.com/p/login/6oEbJB9Xmdl55fG8ww";

function withPrefilledEmail(url: string, email?: string | null): string {
  return email ? `${url}?prefilled_email=${encodeURIComponent(email)}` : url;
}

export function getCheckoutUrl(email?: string | null): string {
  return withPrefilledEmail(CHECKOUT_URL, email);
}

export function getBillingPortalUrl(email?: string | null): string {
  return withPrefilledEmail(BILLING_PORTAL_URL, email);
}

// Why an account is read-only, as reported by check-subscription
export type LapseReason = "trial_ended" | "payment_failed" | "inactive";

export interface Lapse {
  reason: LapseReason;
  email?: string;
}

// What someone needs to do to get full access back
export function getRenewalAction({ reason, email }: Lapse): { text: string; url: string } {
  return reason === "payment_failed"
    ? { text: "Update Payment Method", url: getBillingPortalUrl(email) }
    : { text: "Subscribe for $60/year", url: getCheckoutUrl(email) };
}

// Whole days until a Stripe timestamp, rounded up so the last day reads "1 day"
export function daysUntil(timestampSeconds: number, now: number = Date.now()): number {
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  return Math.max(0, Math.ceil((timestampSeconds * 1000 - now) / millisecondsPerDay));
}
